
import { defineComponent, ref } from 'vue'
import BaseButton from '@/components/BaseButton.vue'
import { useStore } from '@/store'
import { seedLoans } from '@/data/seed'
import { useRouter } from 'vue-router'

export default defineComponent({
  components: {
    BaseButton
  },

  setup () {
    const router = useRouter()
    const { dispatch } = useStore()
    const show = ref(true)
    const resetData = () => {
      dispatch('resetLoans')
      router.push('/')
    }

    const seedData = async () => {
      const loans = seedLoans()

      for (let i = 0; i < loans.length; i++) {
        console.log(`Seeding data for ${loans[i].lender}`)
        await dispatch('createLoan', loans[i])
      }
    }

    return {
      show,
      resetData,
      seedData
    }
  }
})
